(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name crewAirportExpiryReport.controller:CrewAirportExpiryReportCtrl
   *
   * @description
   *
   */
  angular
    .module('crewAirportExpiryReport')
    .controller('CrewAirportExpiryReportCtrl', CrewAirportExpiryReportCtrl);

  function CrewAirportExpiryReportCtrl(CommonLogicService,$sce,CommonMasterData) {
    var vm = this;
    vm.ctrlName = 'CrewAirportExpiryReportCtrl';

    vm.reportTypes = {
      VISITED : 'VISITED',
      NOTVISITED : 'NOTVISITED'
    };
    vm.model = {
      searchPanelToggle: true,
      searchCriteria: {
        fromDate: null,
        toDate: null,
        crewType: null,
        airportCategory: null,
        VISITED:null,
        reportType:false,
        crew: null,
        airportStatus: null

      },
      masterList: {
        crewTypeList: [],
        airportCategorylist: [],
        fromTimeInvalid: false,
        toTimeInvalid: false,
        fromDateRequierd:false,
        toDateRequierd:false,
        disableDate:true,
        airportStatusList: []
      },
      initialSearchDone: false,
      reportDataURL: null,
      reportServerBaseUrl: null
    };

    vm.clickOnSearch = function () {
      vm.model.searchPanelToggle = !vm.model.searchPanelToggle;
      vm.model.initialSearchDone = false;
    };

    // submit search
    vm.submitSearch = function (params) {
      searchcrewAirportExpiryReport(params);
    };

    vm.changeSearchField = function (searchCriteria, flag) {
      if( flag == 'reportType') {
        getReportType(searchCriteria.reportType)
      }
    }
    function searchcrewAirportExpiryReport(param) {
      vm.model.masterList.fromDateRequierd= false;
      vm.model.masterList.toDateRequierd= false;
      vm.model.masterList.fromTimeInvalid = false;
      vm.model.masterList.toTimeInvalid = false;

      vm.model.initialSearchDone = true;
      if (isValidSearchParams(param)) {
        vm.model.searchCriteria = param;
        vm.model.searchPanelToggle = false;
        var type = getReportType(param.reportType);
        var rptDesign = "crew_airport_expiry_report.rptdesign";

        var url = CommonLogicService.getReportUrl(rptDesign, getSearchParamMap(param));
        vm.model.reportDataURL = $sce.trustAsResourceUrl(url);
      }
    }
    function getReportType(reportType){
      if(reportType === null ){
        vm.model.searchCriteria.VISITED = true;
        return vm.reportTypes.VISITED;
      }else if(!reportType){
        vm.model.searchCriteria.VISITED = false;
        return vm.reportTypes.NOTVISITED;
      }else{
        vm.model.searchCriteria.VISITED = true;
        return vm.reportTypes.VISITED;
      }
    }

    function isValidSearchParams(params) {

      var boolReturn  =  true;
      if ((!!vm.model.searchCriteria.crewType)) {
        boolReturn =  true;
      } else{
        return false;
      }
       if(getReportType(params.reportType)==vm.reportTypes.NOTVISITED){
        if(!!vm.model.searchCriteria.fromDate){
          boolReturn= true;
        }else{
          vm.model.masterList.fromDateRequierd =  true;
          return false;
        }
        if(!!vm.model.searchCriteria.toDate){
          boolReturn = true;
        }else{
          vm.model.masterList.toDateRequierd =  true;
           return false;
         }
         setDateValidationFlags();
         if(vm.model.masterList.fromTimeInvalid || vm.model.masterList.toTimeInvalid ){
           return false;
         }else{
           boolReturn = true;
         }
      }

      return boolReturn;
    }
    function setDateValidationFlags() {
      //if from date invalid
      if (isDateFormatInvalid(vm.model.searchCriteria.fromDate)) {
        vm.model.masterList.fromTimeInvalid = true;
      } else {
        vm.model.masterList.fromTimeInvalid = false;
      }
      if (isDateFormatInvalid(vm.model.searchCriteria.toDate)) {
        vm.model.masterList.toTimeInvalid = true;
      } else {
        vm.model.masterList.toTimeInvalid = false;
      }

    }

    function isDateFormatInvalid(date) {
      if (!!date && !moment(date, "DD/MM/YYYY").isValid()) {
        return true;
      }
      return false;
    }

    function getSearchParamMap(param) {
      var searchParamMap = {};
      searchParamMap["crewTypeCode"] = param.crewType.crewTypeCode;
      searchParamMap["visited"]  = getReportType(param.reportType);


      if (!!param.airportCategory) {
        searchParamMap["airportCategory"] = param.airportCategory.code;
      }
      if (!!param.fromDate) {
        searchParamMap["fromDate"] = param.fromDate;
      }

      if (!!param.toDate) {
        searchParamMap["toDate"] = param.toDate;
      }

      if (!!param.airportStatus) {
        searchParamMap["airportStatus"] = param.airportStatus.value;
      }

      searchParamMap["referrer"] = window.location.origin;

      return searchParamMap;
    }



    (function loadCrewTypes() {
      CommonMasterData.getCrewTypeList(function (crewTypeList) {
      var allowedMasterCodes = ["FC", "CC"];  // FC = Flight Crew, CC = Cabin Crew
      var newCrewTypeList = [];
      
      crewTypeList.forEach(function (crewType) {
        if(allowedMasterCodes.indexOf(crewType.crewTypeMasterCode) !== -1) {
          newCrewTypeList.push(crewType);
        }
      });
      vm.model.masterList.crewTypeList = newCrewTypeList;
    },
    function () {
      console.log('Crew type retrieval error');
    }
  );
    })();

    (function loadAirportStatusList() {
      vm.model.masterList.airportStatusList = [
        { desc: 'Yes', value: 'ACT' },
        { desc: 'No', value: 'INA' }
      ];
    })();

    (function loadAirportCategory() {
      CommonMasterData.getAiportCategoriesList(
        function (airportCategories) {
          vm.model.masterList.airportCategorylist = airportCategories;
          // vm.model.masterList.msgRecipients = crewTypes;
        },
        function () {
          console.log('Airport Category retrieval error');
        }
      );
    })();

  }
}());
